import { render, staticRenderFns } from "./AnimatedPrice.vue?vue&type=template&id=6370cfc5&scoped=true&"
import script from "./AnimatedPrice.vue?vue&type=script&lang=js&"
export * from "./AnimatedPrice.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedPrice.vue?vue&type=style&index=0&id=6370cfc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370cfc5",
  null
  
)

export default component.exports